module.exports = __webpack_public_path__ + "gonghuaActive.070420fd.png";